import axios from 'axios';
import authService from "@/services/authService";


const createWorker = async (workerData) => {
    const formData = new FormData();
    formData.append("username", workerData.username);
    formData.append("email", workerData.email);
    formData.append("link", workerData.link);
    formData.append("image", workerData.image);
    formData.append("role", workerData.role);

    return await axios.post(
        `${process.env.VUE_APP_API_URL}/edit/worker/create`,
        formData,
        {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `${authService.getToken()}`,

            },
        }
    );
};

const updateWorker = async (workerData, workerId) => {
    const formData = new FormData();
    if (workerData.username) {
        formData.append("username", workerData.username);

    }
    if (workerData.email) {
        formData.append("email", workerData.email);

    }
    if (workerData.link) {
        formData.append("link", workerData.link);
    }
    if (workerData.image) {
        formData.append("image", workerData.image);

    }

    if (workerData.role) {
        formData.append("role", workerData.role);

    }

    return await axios.put(
        `${process.env.VUE_APP_API_URL}/edit/worker/edit/${workerId}`,
        formData,
        {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `${authService.getToken()}`,

            },
        }
    );
};


const fetchWorker = async (workerId) => {
    try {
        const response = await axios.get(`${process.env.VUE_APP_API_URL}/fetch/worker/${workerId}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching worker:', error);
        throw error;
    }
};

const fetchProfilePicture = async (workerId) => {
    try {
        return `${process.env.VUE_APP_API_URL}/fetch/pfp/${workerId}`;
    } catch (error) {
        console.error('Error fetching profile picture URL:', error);
        throw error;
    }
};

const deleteWorker = async (workerId) => {
    try {
        const response = await axios.delete(`${process.env.VUE_APP_API_URL}/edit/worker/delete/${workerId}`, {
            headers: {
                Authorization: `${authService.getToken()}`,
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error deleting worker:', error);
        throw error;
    }
};

const fetchWorkers = async () => {
    try {
        const response = await axios.get(`${process.env.VUE_APP_API_URL}/fetch/workers`);
        return response.data;
    } catch (error) {
        console.error('Error fetching workers:', error);
        throw error;
    }
};




export default {
    createWorker,
    fetchWorker,
    fetchProfilePicture,
    fetchWorkers,
    deleteWorker,
    updateWorker
};
